// slices/voucherTypeKarmaMasterSlice.ts

import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface VoucherTypeKarmaMasterState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allVoucherTypeKarmaMasterList: any[];
}

const initialState: VoucherTypeKarmaMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allVoucherTypeKarmaMasterList: [],
};

export const voucherTypeKarmaMasterSlice = createSlice({
  name: 'voucherTypeKarmaMaster',
  initialState,
  reducers: {
    setVoucherTypeKarmaMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setVoucherTypeKarmaMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllVoucherTypeKarmaMaster: (state, action) => {
      state.allVoucherTypeKarmaMasterList = action.payload.data;
    },
    resetVoucherTypeKarmaMaster: () => initialState,
  },
});

export const {
  setVoucherTypeKarmaMaster,
  setVoucherTypeKarmaMasterBySearch,
  setAllVoucherTypeKarmaMaster,
  resetVoucherTypeKarmaMaster,
} = voucherTypeKarmaMasterSlice.actions;

export const getVoucherTypeKarmaMasterData = (state: RootState) => state.voucherTypeKarmaMaster.data;
export const getVoucherTypeKarmaMasterList = (state: RootState) => state.voucherTypeKarmaMaster?.allVoucherTypeKarmaMasterList;
export const getVoucherTypeKarmaMasterTotalRecords = (state: RootState) => state.voucherTypeKarmaMaster.totalRecords;
export const getVoucherTypeKarmaMasterBySearch = (state: RootState) => state.voucherTypeKarmaMaster.data;

export default voucherTypeKarmaMasterSlice.reducer;
